import $ from "jquery";

// npm install jquery.scrollto

$(function() {
    $("#totopbutton").on("click", function() {
        $(window).scrollTo(0, 1500);
    });
});
